import wireHero from '../assets/images/wire-hero.jpg';
import wireProduct from '../assets/images/wire-product.jpg';
import fanHero from '../assets/images/fan-hero-banner.webp';
import fanActiva from '../assets/images/fan-activa.webp';
import fanAmazer from '../assets/images/fan-amazer-charcoal.png';
import fanClassic from '../assets/images/fan-classic.png';
import fanSmartDeluxe from '../assets/images/fan-smart-deluxe.webp';
import fanStyler from '../assets/images/fan-styler.webp';
import fanWhiteGold from '../assets/images/fan-white-gold.png';
import fanSmartBrown from '../assets/images/fan-smart-brown.png';
import fanCashio from '../assets/images/fan-cashio.webp';
import fanMicro from '../assets/images/fan-micro.webp';
import fanNexo from '../assets/images/fan-nexo.webp';
import fanSmartest from '../assets/images/fan-smartest.webp';
import fanSmartDlx600 from '../assets/images/fan-smart-dlx-600.webp';
import fanSmart600 from '../assets/images/fan-smart-600.webp';
import heatshieldHero from '../assets/images/heatshield-hero.jpg';
import heatshieldBanner from '../assets/images/heatshield-banner.jpg';
import heatshieldProduct from '../assets/images/heatshield-product.jpg';
import indrasonBanner from '../assets/images/indrason-banner.webp';
import indrasonProduct from '../assets/images/indrason-product.jpg';
import indrasonLogo from '../assets/images/indrason-logo.png';
import flexibleCable from '../assets/images/flexible-cable.jpg';
import indrason2Core from '../assets/images/indrason-2core.webp';
import nishad2Core from '../assets/images/nishad-2core.webp';
import nishadTwinflat from '../assets/images/nishad-twin-flat-cable.webp';
import indrasonFRMultistand from '../assets/images/indrason-fr-multistand.webp';
import orbitStar from '../assets/images/orbit-star.webp';
import orbitStarDiwaliBanner from '../assets/images/orbit-star-diwali-banner.jpg';
import orbitStarDiwaliBannerMobile from '../assets/images/orbit-star-diwali-banner-mobile.jpg';
import orbitStarDiwaliBannerWebp from '../assets/images/orbit-star-diwali-banner.webp';
import orbitStarDiwaliBannerMobileWebp from '../assets/images/orbit-star-diwali-banner-mobile.webp';
import orbitStar20mLifestyle from '../assets/images/orbit-star-20m-lifestyle.webp';
import orbitStar20mColours from '../assets/images/orbit-star-20m-colours.webp';
import orbitStar20mBox from '../assets/images/orbit-star-20m-box.webp';
import orbitStar20mWarmWhite from '../assets/images/orbit-star-20m-warm-white.webp';
import orbitStar20mWhite from '../assets/images/orbit-star-20m-white.webp';
import orbitStar20mBlue from '../assets/images/orbit-star-20m-blue.webp';
import orbitStar20mRed from '../assets/images/orbit-star-20m-red.webp';
import orbitStar20mGreen from '../assets/images/orbit-star-20m-green.webp';
import orbitStar20mPink from '../assets/images/orbit-star-20m-pink.webp';
import orbitStar15mColours from '../assets/images/orbit-star-15m-colours.webp';
import orbitStar15mBalcony from '../assets/images/orbit-star-15m-balcony.webp';
import orbitStar15mFeatures from '../assets/images/orbit-star-15m-features.webp';
import orbitStar15mBox from '../assets/images/orbit-star-15m-box.webp';
import orbitStar15mLifestyle from '../assets/images/orbit-star-15m-lifestyle.webp';
import orbitStar15mLabel from '../assets/images/orbit-star-15m-label.webp';
import orbitStar15mWarmWhite from '../assets/images/orbit-star-15m-warm-white.webp';
import orbitStar15mWhite from '../assets/images/orbit-star-15m-white.webp';
import orbitStar15mBlue from '../assets/images/orbit-star-15m-blue.webp';
import orbitStar15mRed from '../assets/images/orbit-star-15m-red.webp';
import orbitStar15mGreen from '../assets/images/orbit-star-15m-green.webp';
import orbitStar15mPink from '../assets/images/orbit-star-15m-pink.webp';
import orbitStar15mBalconyThumb from '../assets/images/thumbs/orbit-star-15m-balcony-thumb.webp';
import orbitStar15mBlueThumb from '../assets/images/thumbs/orbit-star-15m-blue-thumb.webp';
import orbitStar15mBoxThumb from '../assets/images/thumbs/orbit-star-15m-box-thumb.webp';
import orbitStar15mColoursThumb from '../assets/images/thumbs/orbit-star-15m-colours-thumb.webp';
import orbitStar15mFeaturesThumb from '../assets/images/thumbs/orbit-star-15m-features-thumb.webp';
import orbitStar15mGreenThumb from '../assets/images/thumbs/orbit-star-15m-green-thumb.webp';
import orbitStar15mLabelThumb from '../assets/images/thumbs/orbit-star-15m-label-thumb.webp';
import orbitStar15mLifestyleThumb from '../assets/images/thumbs/orbit-star-15m-lifestyle-thumb.webp';
import orbitStar15mPinkThumb from '../assets/images/thumbs/orbit-star-15m-pink-thumb.webp';
import orbitStar15mRedThumb from '../assets/images/thumbs/orbit-star-15m-red-thumb.webp';
import orbitStar15mWarmWhiteThumb from '../assets/images/thumbs/orbit-star-15m-warm-white-thumb.webp';
import orbitStar15mWhiteThumb from '../assets/images/thumbs/orbit-star-15m-white-thumb.webp';
import orbitStar20mBlueThumb from '../assets/images/thumbs/orbit-star-20m-blue-thumb.webp';
import orbitStar20mBoxThumb from '../assets/images/thumbs/orbit-star-20m-box-thumb.webp';
import orbitStar20mColoursThumb from '../assets/images/thumbs/orbit-star-20m-colours-thumb.webp';
import orbitStar20mGreenThumb from '../assets/images/thumbs/orbit-star-20m-green-thumb.webp';
import orbitStar20mLifestyleThumb from '../assets/images/thumbs/orbit-star-20m-lifestyle-thumb.webp';
import orbitStar20mPinkThumb from '../assets/images/thumbs/orbit-star-20m-pink-thumb.webp';
import orbitStar20mRedThumb from '../assets/images/thumbs/orbit-star-20m-red-thumb.webp';
import orbitStar20mWarmWhiteThumb from '../assets/images/thumbs/orbit-star-20m-warm-white-thumb.webp';
import orbitStar20mWhiteThumb from '../assets/images/thumbs/orbit-star-20m-white-thumb.webp';
// TODO: swap these to real files once added at src/assets/images/accessories-price-list-a.jpg and accessories-price-list-b.jpg
const accessoriesPriceListA = heatshieldBanner;
const accessoriesPriceListB = heatshieldBanner;
const pageAssets = {
    wireHero,
    wireProduct,
    fanHero,
    fanActiva,
    fanAmazer,
    fanClassic,
    fanSmartDeluxe,
    fanStyler,
    fanWhiteGold,
    fanSmartBrown,
    fanCashio,
    fanMicro,
    fanNexo,
    fanSmartest,
    fanSmartDlx600,
    fanSmart600,
    heatshieldHero,
    heatshieldBanner,
    heatshieldProduct,
    indrasonBanner,
    indrasonProduct,
    indrasonLogo,
    flexibleCable,
    indrason2Core,
    nishad2Core,
    nishadTwinflat,
    indrasonFRMultistand,
    orbitStar,
    orbitStarDiwaliBanner,
    orbitStarDiwaliBannerMobile,
    orbitStarDiwaliBannerWebp,
    orbitStarDiwaliBannerMobileWebp,
    orbitStar20mLifestyle,
    orbitStar20mColours,
    orbitStar20mBox,
    orbitStar20mWarmWhite,
    orbitStar20mWhite,
    orbitStar20mBlue,
    orbitStar20mRed,
    orbitStar20mGreen,
    orbitStar20mPink,
    orbitStar15mColours,
    orbitStar15mBalcony,
    orbitStar15mFeatures,
    orbitStar15mBox,
    orbitStar15mLifestyle,
    orbitStar15mLabel,
    orbitStar15mWarmWhite,
    orbitStar15mWhite,
    orbitStar15mBlue,
    orbitStar15mRed,
    orbitStar15mGreen,
    orbitStar15mPink,
    orbitStar15mBalconyThumb,
    orbitStar15mBlueThumb,
    orbitStar15mBoxThumb,
    orbitStar15mColoursThumb,
    orbitStar15mFeaturesThumb,
    orbitStar15mGreenThumb,
    orbitStar15mLabelThumb,
    orbitStar15mLifestyleThumb,
    orbitStar15mPinkThumb,
    orbitStar15mRedThumb,
    orbitStar15mWarmWhiteThumb,
    orbitStar15mWhiteThumb,
    orbitStar20mBlueThumb,
    orbitStar20mBoxThumb,
    orbitStar20mColoursThumb,
    orbitStar20mGreenThumb,
    orbitStar20mLifestyleThumb,
    orbitStar20mPinkThumb,
    orbitStar20mRedThumb,
    orbitStar20mWarmWhiteThumb,
    orbitStar20mWhiteThumb,
    accessoriesPriceListA,
    accessoriesPriceListB
};

export default pageAssets;
